module.exports = __webpack_public_path__ + "static/media/block-3-item-1.a76a8400.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/block-3-item-1.jpg
// module id = 1257
// module chunks = 270